import { Injectable } from '@angular/core';

class ExportFileType {
  constructor(
    public type: string,
    public extension: string
  ) {}
}

const CSV_FILE = new ExportFileType('text/csv;charset=utf-8', '.csv');

@Injectable()
export class FileExportService {

  constructor() { }

  public exportAsCsvFile(json: any[], fileName: string, headers: any = null, footer: any = null): void {

    this.exportFile(CSV_FILE, json, fileName, headers, footer);
  }

  private exportFile(
    fileType: ExportFileType,
    items: any[],
    fileName: string,
    headers: any = null,
    footer: any = null): void {

    const fields = Object.keys(items[0]);
    if (!headers) {
      headers = {};
      fields.forEach(f => headers[f] = f);
    }
    items.unshift({});
    items.unshift(headers);
    if (footer) {
      items.push({});
      items.push(footer);
    }
    const csv = items.map(row => fields.map(fieldName => this.formatValue(row[fieldName])).join(','));
    const csvFile = csv.join('\r\n');
    this.saveFile(fileType, csvFile, fileName);
  }

  private formatValue(value: string) {
    if (value) {
      if (value.includes(',')) {
        return JSON.stringify(value);
      } else {
        return value;
      }
    } else {
      return '';
    }
  }

  private saveFile(fileType: ExportFileType, buffer: any, fileName: string): void {
    buffer = '\ufeff' + buffer; // Prepend a byte-order mark so Excel reads the file with the proper encoding.
    const blob: Blob = new Blob([buffer], {type: fileType.type});

    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = window.URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName + fileType.extension);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }
}
